const home = {
  hero: {
    badge: "Independent Resource Hub",
    title: "USFans Spreadsheet: Find, Compare & Explore Resources",
    subtitle: "Explore the USFans Spreadsheet, product categories, seller information, shipping guides, reviews, coupons, warehouse details and practical research tools — all organized in one easy-to-use resource hub.",
    searchPlaceholder: "Search products, sellers, shipping or guides...",
    trust: "Independent Resource · Updated Guides · Multilingual · Safety-Focused",
    primaryCta: "Explore USFans Spreadsheet",
    secondaryCta: "Visit Main Website",
    supportTitle: "Looking for a USFans Spreadsheet?",
    supportText: "Find organized resources, research guides, comparisons and practical information to help you understand USFans before making a decision.",
    explore: [
      "Spreadsheet resources",
      "Product research",
      "Seller information",
      "Shipping costs",
      "Warehouse guides",
      "Reviews",
      "Coupons and discount information",
      "Safety tips",
    ],
  },
  cta: {
    exploreSpreadsheet: "Explore Spreadsheet",
    usfansSpreadsheet: "USFans Spreadsheet",
    buyItNow: "Buy It Now",
    visitMain: "Visit Main Website",
    exploreAll: "Explore All Resources",
    continueMain: "Continue to Main Website",
  },
  categories: {
    title: "Browse Product Categories",
    subtitle: "Choose a category below to explore the latest products available on the main website.",
    dropdownLabel: "Select a category",
    dropdownPlaceholder: "Choose a product category...",
    items: {
      shoes: "Shoes",
      hoodies: "Hoodies / Sweaters",
      tshirts: "T-Shirts",
      jackets: "Jackets",
      pants: "Pants / Shorts",
      headwear: "Headwear",
      sets: "Sets",
      underwear: "Underwear / Underpants",
      jersey: "Jersey",
      accessories: "Accessories",
      bags: "Bags",
      belts: "Belts",
      perfumes: "Perfumes",
      other: "Other Stuff",
    },
  },
  resources: {
    title: "Popular Resources",
    subtitle: "Everything you need to research USFans, organized into simple topics.",
    items: [
      { title: "USFans Spreadsheet", desc: "Explore spreadsheet resources, lists and research guides." },
      { title: "USFans Review", desc: "Understand features, advantages, limitations and considerations." },
      { title: "USFans Shipping Cost", desc: "Learn what affects shipping costs and how to compare options." },
      { title: "USFans Warehouse", desc: "Understand storage, processing and related considerations." },
      { title: "Coupon & Discount Code", desc: "Find current coupon and discount information when available." },
      { title: "Is USFans Legit?", desc: "Read our independent safety and legitimacy guide." },
    ],
  },
  hub: {
    title: "Your USFans Spreadsheet Resource Hub",
    copy: "USFansSheet.live organizes USFans Spreadsheet resources into searchable categories so you can spend less time searching and more time researching.",
    cards: ["Spreadsheet Lists", "Product Research", "Seller Research", "Shipping", "Warehouse", "Reviews", "Coupons", "Safety"],
  },
  why: {
    title: "Everything You Need to Research USFans in One Place",
    items: [
      { title: "Organized", desc: "Find related USFans Spreadsheet information without jumping between unrelated pages." },
      { title: "Practical", desc: "Guides focus on real questions people actually search for." },
      { title: "Updated", desc: "Important information shows published and updated dates." },
      { title: "Transparent", desc: "Clearly distinguish verified facts, editorial analysis and changeable information." },
      { title: "Multilingual", desc: "Available in English, Polish, Spanish and French." },
    ],
  },
  comparison: {
    title: "USFans Resources Compared",
    subtitle: "A quick look at what each resource helps you learn and who it is best for.",
    headers: ["Topic", "What You Can Learn", "Best For"],
    rows: [
      ["Spreadsheet", "Lists, products & research", "Product research"],
      ["Review", "Features & limitations", "Beginners"],
      ["Shipping Cost", "Cost factors & options", "Shipping research"],
      ["Warehouse", "Storage & processing", "Existing users"],
      ["Coupon", "Available promotions", "Saving money"],
      ["Legit Guide", "Safety & verification", "Risk awareness"],
    ],
  },
  guides: {
    title: "Latest Guides",
    subtitle: "Read our original, independently written guides and articles.",
    readGuide: "Read Guide",
    readArticle: "Read Article",
    comingSoon: "Coming soon",
    updatedLabel: "Updated",
  },
  articleSection: {
    title: "USFans Spreadsheet Articles",
    subtitle: "Original in-depth guides to help you research and understand USFans.",
    cardTitle: "What Is a USFans Spreadsheet?",
    cardDesc: "A complete beginner-friendly guide to how the USFans Spreadsheet works, how to search it, and how to stay safe.",
    readMore: "Read the full guide",
  },
  safety: {
    title: "Research Before You Buy",
    copy: "Online resources can change. Links, sellers, prices, shipping conditions and promotions may not always remain current. Always verify important information before making payments or sharing personal information.",
    cta: "Read the USFans Safety Guide",
  },
  mainCta: {
    title: "Ready to Explore More?",
    copy: "Use our guides and USFans Spreadsheet resources as a starting point, then continue to the main website for the latest available information.",
  },
  faq: {
    title: "Frequently Asked Questions",
    items: [
      { q: "What is a USFans Spreadsheet?", a: "A USFans Spreadsheet is an organized, searchable resource that lists and compares products, categories, sellers and related research information. It helps shoppers find what they are looking for faster." },
      { q: "How does a USFans Spreadsheet work?", a: "It groups products and information into categories so you can browse, search and compare options in one place instead of visiting many separate pages." },
      { q: "Is USFans legit?", a: "We provide independent guidance to help you verify information, but we cannot guarantee the legitimacy of any seller. Always research carefully and check current information before purchasing." },
      { q: "How much does USFans shipping cost?", a: "Shipping costs can change depending on location, method and the seller. We explain the factors that affect shipping so you can compare options yourself." },
      { q: "Does USFans offer coupons?", a: "Promotions and coupons may be available at certain times. We describe how to look for current deals, but we do not list guaranteed or unverified discount codes." },
      { q: "Where can I find USFans discount codes?", a: "Always look for codes on the official main website or verified channels. Be careful with unofficial codes that may be outdated or misleading." },
      { q: "What is the USFans warehouse?", a: "The warehouse relates to how products are stored and processed before shipping. We explain the general concept and things to consider." },
      { q: "Is the USFans Spreadsheet official?", a: "USFansSheet.live is an independent informational resource and is not necessarily affiliated with or endorsed by USFans." },
      { q: "How do I verify information?", a: "Cross-check details on the main website, look at recent updates, and confirm prices, shipping and availability before making payments or sharing personal data." },
      { q: "How often are resources updated?", a: "We aim to keep information current, but details can change quickly. Always check the main website for the latest information." },
    ],
  },
};

export default home;